import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/store';
import { setScreenSize } from '@/store/slices/uiSlice';
import Sidebar from './Sidebar';
import Header from './Header';
import { useResponsive } from '@/hooks';

const EmployerLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const { sidebarOpen } = useAppSelector(state => state.ui);
  const { screenSize } = useResponsive();

  useEffect(() => {
    dispatch(setScreenSize(screenSize));
  }, [dispatch, screenSize]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main
          className={`flex-1 overflow-y-auto p-4 lg:p-6 transition-all duration-200 ${
            sidebarOpen ? '' : 'lg:ml-0'
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default EmployerLayout;
